<script>
	let className = $$props.class ? " " + $$props.class : "";
</script>

<div class="form-group form-row{className}"><slot></slot></div>

<style>
	.list-header-row {
		margin-bottom: 6px;
		font-size: 0.9em;
		font-weight: 700;
	}
</style>
